import { render, staticRenderFns } from "./shebao_tuifei.vue?vue&type=template&id=4b7567fc&scoped=true"
import script from "./shebao_tuifei.vue?vue&type=script&lang=js"
export * from "./shebao_tuifei.vue?vue&type=script&lang=js"
import style0 from "./shebao_tuifei.vue?vue&type=style&index=0&id=4b7567fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7567fc",
  null
  
)

export default component.exports